import { type WithIsVisibleHOCProps } from "@client/hocs/withIsVisible";
import { connectCustom } from "@client/lib/misc";
import { stateSelectors } from "@client/selectors";
import { type AppState, type WithClassName } from "@client/types";
import { setSticky } from "./actions";
import Header, { type ActionProps, INVISIBLE_PROPS, type MapProps } from "./component";
import {
  classNameSelector,
  containerStyleSelector,
  contentStyleSelector,
  headerStickySelector,
  headerVisibilitySelector,
  isMenuOpenSelector,
  isStickySelector,
  styleSelector
} from "./selectors";

export type HeaderContainerProps = Partial<WithClassName> & {
  onDoubleClick?: () => void;
};
const mapStateToProps = (state: AppState, props: HeaderContainerProps): MapProps & WithIsVisibleHOCProps => {
  const layoutId = stateSelectors.page.layoutId(state);
  if (!layoutId) return INVISIBLE_PROPS;

  const visibility = headerVisibilitySelector(state);
  if (!visibility.isVisible) return INVISIBLE_PROPS;

  return {
    className: classNameSelector(state, props),
    isMenuOpen: isMenuOpenSelector(state),
    containerStyle: containerStyleSelector(state),
    contentStyle: contentStyleSelector(state),
    isSticky: headerStickySelector(state),
    isStickyActive: isStickySelector(state),
    style: styleSelector(state),
    isVisible: true
  };
};

const mapDispatchToProps = (dispatch: any, props: Partial<ActionProps>): ActionProps => ({
  onDoubleClick: props.onDoubleClick,
  setSticky: (isSticky: boolean) => dispatch(setSticky(isSticky))
});

export default connectCustom(mapStateToProps, mapDispatchToProps, { forwardRef: true })(Header);
